export default __webpack_public_path__ + "static/media/tool_youtube.d24d71b0.png";